import { Col, Row } from "react-bootstrap";
import { WfsParametersV2 } from "../../../types/Wfs/WfsParametersV2";
import { useMemo } from "react";

export interface MRNFiltersProps {
  wfsParameters: WfsParametersV2;
}

const MRNFilters = ({ wfsParameters }: MRNFiltersProps) => {
  const access = useMemo(() => {
    if (!wfsParameters.filter) return false;
    const pattern = new RegExp(/access\s+!=\s+"no"/, "i");
    return pattern.test(wfsParameters.filter);
  }, [wfsParameters.filter]);

  return (
    <>
      <Row>
        <Col md="3">Exclude Inaccessible Links</Col>
        <Col md="9">{access ? "Accessible Only" : "All Links"}</Col>
      </Row>
      {wfsParameters.users && (
        <Row>
          <Col md="3">Users / Terminals</Col>
          <Col md="9">{wfsParameters.users}</Col>
        </Row>
      )}
    </>
  );
};

export default MRNFilters;
